export function stripMarkdown(input) {
  let s = String(input || '');

  // Strip HTML tags (AI may return HTML bodies)
  s = s.replace(/<[^>]+>/g, ' ');

  // Remove fenced code blocks
  s = s.replace(/```[\s\S]*?```/g, ' ');
  // Remove inline code
  s = s.replace(/`([^`]+)`/g, '$1');
  // Remove images ![alt](url)
  s = s.replace(/!\[([^\]]*)\]\([^)]+\)/g, '$1');
  // Replace links [text](url) -> text
  s = s.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1');

  // Strip headings markers
  s = s.replace(/^\s{0,3}#{1,6}\s+/gm, '');
  // Strip blockquotes
  s = s.replace(/^\s{0,3}>\s?/gm, '');
  // Strip list markers
  s = s.replace(/^\s*[-*+]\s+/gm, '');
  s = s.replace(/^\s*\d+\.\s+/gm, '');
  // Strip horizontal rules
  s = s.replace(/^\s*(?:-{3,}|_{3,}|\*{3,})\s*$/gm, ' ');

  // Strip emphasis markers
  s = s.replace(/\*\*([^*]+)\*\*/g, '$1');
  s = s.replace(/\*([^*]+)\*/g, '$1');
  s = s.replace(/__([^_]+)__/g, '$1');
  s = s.replace(/_([^_]+)_/g, '$1');
  s = s.replace(/~~([^~]+)~~/g, '$1');

  // Collapse whitespace
  s = s.replace(/\s+/g, ' ').trim();
  return s;
}


